import React, { useEffect, useRef, useState } from "react";
import LoginHeader from "../Component/LoginHeader";
import Callimaga from "../assets/img/call.svg";
import { Formik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import LoginIMG from "../assets/img/Nurse1.png";
import AxiosInstance from "../utils/AxiosInstance";
import Icon1 from "../assets/img/ufo-balun.svg";
import Icon2 from "../assets/img/ufo-earthsec.svg";
import Icon3 from "../assets/img/ufo_setlitesec.svg";
import Icon4 from "../assets/img/ufo_telescope.svg";
import loginBg from "../assets/img/login_bg.png";
import MainLogo from "../assets/img/mergeLogo.svg";
import topLogo from "../assets/img/text-logo.png";
import { Link, useNavigate } from "react-router-dom";
import { LoginForm } from "../utils/ValidationSchema";
import { toast } from "react-toastify";
import OtpModal from "../Component/OtpModal";
import ErrorComponent from "../Component/ErrorComponent";
import { useLocalization } from "../Component/Localization/Localization";
import CountrySelect from "../Component/CountryDrop";
import { Col, Image, Row } from "react-bootstrap";

function Login() {
  const { t, locale } = useLocalization();
  const [otpmodal, setOtpModal] = useState(false);
  const [country, setCountry] = useState();
  const [mobile, setMobile] = useState("");
  const [phones, setPhone] = useState("971");

  const navigate = useNavigate();
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (otpmodal && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, [otpmodal]);
  const handleSubmit = async ({ phone }) => {
    try {
      const data = {
        mobile: "+" + phones + " " + phone,
        role: "staff",
      };
      const resposnswe = await AxiosInstance.post("/auth/send-otp", data);
      if (resposnswe.status == 200) {
        setOtpModal(true);
      }
    } catch (error) {
      // console.log("error.response?.data.message",error)
      toast.error(error.response?.data.message);
    }
  };

  const inputs = Array(4).fill("");
  const handleChanges = (index, e) => {
    const value = e.target.value;

    // Set the input value
    if (value) {
      inputRefs.current[index].value = value;
    }

    // Move focus to the next input box
    if (index < 4 - 1 && value) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Function to handle input keydown
  const handleInputKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const SendOtp = async () => {
    setOtpValues(["", "", "", ""]);
    try {
      // after otp input for token --->auth/login
      const data = {
        mobile: "+" + phones + " " + mobile,
        role: "staff",
      };
      const resposnswe = await AxiosInstance.post("/auth/send-otp", data);
      if (resposnswe.status == 200) {
        toast.success("Otp Resent SuccessFully");
      }
    } catch (error) {
      // toast.error(error.message);
      toast.error(error.response?.data?.message);
    }
  };
  const AuthenticateVerify = async () => {
    try {
      const data = {
        userInput: "+" + phones + " " + mobile,
        otp: inputRefs.current.reduce((acc, input) => acc + input.value, ""),
        role: "staff",
      };
      const resposnswe = await AxiosInstance.post("/auth/login", data);

      if (resposnswe.status == 200) {
        if (resposnswe?.data?.data?.user?.role?.name == "nurse") {
          toast.success("Otp Verify Suceesfully");
          localStorage.setItem(
            "auth_token_nurse",
            resposnswe?.data?.data?.token
          );
          localStorage.setItem("user_id", resposnswe?.data?.data?.user?._id);

          navigate("/dashboard");
        } else {
          toast.dismiss();
          toast.error(
            "Invalid number for this role. Please check and try again."
          );
        }
      } else {
        toast.error(resposnswe?.data?.message);
        navigate(`/AccountActivation`);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  return (
    <div className="login-page" style={{ marginTop: "-81px" }}>
      <img className="fxed-img" src={loginBg} alt="img" />
      {/* <LoginHeader /> */}
      {/* <img class="vctr-img" src={Icon1} alt="" />
      <img class="vctr-img-1" src={Icon2} alt="" />
      <img class="vctr-img-2" src={Icon3} alt="" />
      <img class="vctr-img-3" src={Icon4} alt="" /> */}

      <div className={locale == "ar" ? "main-login directions" : "main-login"}>
        <Row className="login-section " style={{ height: "100vh" }}>
          <Col
            xs={12}
            lg={8}
            className="d-none d-lg-flex flex-column align-items-start justify-content-center"
          >
            {/* Centered text content */}
            <div className="d-none d-lg-flex w-100 mt-4">
              <Image
                src={topLogo}
                alt="StarsAI Logo"
                style={{ width: "120px" }}
              />
            </div>
            {/* <LoginHeader /> */}
            <div className="d-none d-lg-flex flex-column flex-grow-1 justify-content-center gap-2">
              <h1 className="fw-bold text-black">Empowering K-12 Schools</h1>
              <h1 className="fw-light text-black">
                <span className="login-page-leftTitle">StarsAI</span> A Single
                SaaS Solution
              </h1>
              <div className="gradient-bar"></div>
              <h3 className="mt-3">Leading Innovation Across the UAE & GCC</h3>
            </div>
          </Col>
          <Col
            xs={12}
            lg={4}
            className="d-flex flex-column justify-content-center align-items-center text-center gap-2"
          >
            <div className="login_form">
              {/* <h3> {t("teacher_login")}</h3>
                  <p>{t("description_login")}</p> */}
              <div className="mb-3">
                <Image
                  src={MainLogo}
                  alt="Main Logo"
                  style={{ width: "180px" }}
                />
              </div>

              <h2 className="fw-bold">
                Login to{" "}
                <span className="login-page-leftTitle">Nurses Panel</span>
              </h2>
              <Formik
                initialValues={{
                  phone: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={LoginForm}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <form className="cmn-frm" onSubmit={handleSubmit}>
                    <div
                      className="hellos"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBlock: "15px",
                      }}
                    >
                      <PhoneInput
                        country={"eg"}
                        className="country-selector"
                        enableSearch={true}
                        value={phones}
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={(phone) => setPhone(phone)}
                      />
                      <div
                        className={otpmodal ? "phone-filed" : "formMargin"}
                        style={{ width: "100%", position: "relative" }}
                      >
                        <input
                          type="number"
                          name="phone"
                          className="ml-5"
                          onChange={(e) => {
                            handleChange(e);
                            setMobile(e.target.value);
                          }}
                          value={values.phone}
                          placeholder="Enter number here"
                        />
                        <img
                          className="ipt-icn img-fluid"
                          src={Callimaga}
                          alt=""
                        />
                      </div>
                    </div>

                    <ErrorComponent
                      error={errors.phone && touched.phone && errors.phone}
                    />
                    {otpmodal && (
                      <div className="form-group otp-filds">
                        {inputs?.map((value, index) => (
                          <input
                            key={index}
                            type="text"
                            placeholder={index + 1}
                            maxLength={1}
                            // value={value}
                            ref={(el) => (inputRefs.current[index] = el)}
                            onChange={(e) => handleChanges(index, e)}
                            onKeyDown={(event) => {
                              handleInputKeyDown(event, index);
                            }}
                          />
                        ))}
                      </div>
                    )}
                    {!otpmodal && (
                      <>
                        <button
                          className="btn-btn-primary mt-2 rounded-pill px-5"
                          type="submit"
                        >
                          {/* SEND OTP */}
                          {t("sent_otp_btn_txt")}
                        </button>
                        {/* <h6 className="activet-act">
                                  {t("dont_have_account")}{" "}
                                  <Link
                                    className="text-btn"
                                    to="/AccountActivation"
                                  >
                                    {t("activate_account")}
                                  </Link>
                                </h6> */}
                      </>
                    )}

                    {otpmodal && (
                      <>
                        <button
                          onClick={AuthenticateVerify}
                          className="btn-btn-primary mt-2 rounded-pill"
                          type="button"
                        >
                          {t("submit_btn_txt")}
                        </button>
                        <h6 className="activet-act">
                          {t("didnt_recive_otp")}
                          <span className="text-btn cursors" onClick={SendOtp}>
                            {" "}
                            {t("sent_again")}
                          </span>
                        </h6>
                      </>
                    )}
                  </form>
                )}
              </Formik>

              {/* {otpmodal && (
                        <form action="" className="cmn-frm ">
                        

                          <button
                            onClick={AuthenticateVerify}
                            className="btn-btn-primary mt-2"
                            type="button"
                          >
                            {t("submit_btn_txt")}
                          </button>
                          <h6 className="activet-act">
                            {t("didnt_recive_otp")}
                            <span
                              className="text-btn cursors"
                              onClick={SendOtp}
                            >
                              {" "}
                              {t("sent_again")}
                            </span>
                          </h6>
                        </form>
                      )} */}
            </div>
          </Col>
        </Row>
      </div>

      {/* <OtpModal
        show={otpmodal}
        onHide={() => setOtpModal(false)}
        mobile={mobile}
      /> */}
    </div>
  );
}

export default Login;
